var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCurvy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M17.827 1.84a2 2 0 0 0-2.654 0L12.81 3.933 9.69 3.45a2 2 0 0 0-2.232 1.434l-.856 3.04-2.887 1.28a2 2 0 0 0-1.102 2.412l.924 3.02L1.8 17.273a2 2 0 0 0 .377 2.627l2.41 2.04-.035 3.158a2 2 0 0 0 1.737 2.005l3.13.414 1.678 2.676a2 2 0 0 0 2.546.747l2.857-1.343 2.858 1.343a2 2 0 0 0 2.545-.747l1.678-2.676 3.13-.414a2 2 0 0 0 1.737-2.005l-.035-3.157 2.41-2.041a2 2 0 0 0 .377-2.627l-1.737-2.637.924-3.02-.957-.292.957.293a2 2 0 0 0-1.102-2.414l-2.887-1.28-.856-3.039A2 2 0 0 0 23.31 3.45l-3.12.484z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "m11.063 18.313 3.02 3.02 8.459-8.458"
})));
export default SvgCheckCurvy;